/*
 * Module for the move topics/content modal, which moves contents or topics from one folder to another
 * The module loads an instance of navTree (with its own namespace)
 */

define([
  "marionette",
  "jquery",
  "messaging/messenger",
  "modules/shared/moveModal/moveModalView",
  "modules/shared/navTree/navTreeModule",
], function (Marionette, $, Messenger, MoveModalView, NavTreeModule) {
  var MoveModalController = Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "moveModal";
      this.region = options.region;
      this._setUpVents();
    },
    //pass the root folder so that we don't have to request another one from the server
    show: function (args) {
      var rootGroup = args.rootGroup;
      var modelsToMove = args.modelsToMove; //if no modelsToMove are provided, it assumes it is moving the folder
      var currentGroup = args.group;
      this.layout = new MoveModalView.moveModalLayout();
      this.moveTree = this.addSubModule(
        new NavTreeModule({
          region: this.layout.moveTree,
          nameAttribute: args.nameAttribute,
          namespace: "move:modal",
        }),
      );
      this.layout.on(
        "done",
        function () {
          if (this.selectedGroup) {
            if (modelsToMove) {
              currentGroup.move(modelsToMove, this.selectedGroup);
            } else {
              currentGroup.moveFolder(this.selectedGroup);
            }
            Messenger.vent.trigger("close:modal");
          } else {
            this.moveError($.t("move.noSelectionError"));
          }
        },
        this,
      );
      this.layout.on(
        "cancel",
        function () {
          if (!modelsToMove) {
            //if we are moving a folder, then move the folder to the original parent
            currentGroup.moveFolder(currentGroup.parent);
          }
          Messenger.vent.trigger("close:modal");
        },
        this,
      );
      this.layout.on(
        "show",
        function () {
          this._showSubViews(rootGroup);
        },
        this,
      );
      this.showRegion(this.layout);
    },
    clearError: function () {
      this.layout.clearError();
    },
    moveError: function (errorMessage) {
      this.layout.moveError(errorMessage);
    },
    _showSubViews: function (rootGroup) {
      this.moveTree.show(rootGroup);
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "move:modal:select:group",
        function (groupView) {
          this.selectedGroup = groupView.model;
        },
        this,
      );
    },
  });

  return MoveModalController;
});
